import type { SupportedLocale } from '@erp/shared';

export const productUnitsTranslations: Record<
  SupportedLocale,
  { loadError: string; unavailable: string; locked: string }
> = {
  de: {
    loadError: 'Die Basiseinheiten konnten nicht geladen werden.',
    unavailable:
      'Diese Basiseinheit ist nicht verfügbar. Speichern Sie sie zuerst in der geführten Einrichtung.',
    locked: 'Die Basiseinheit kann nach der ersten Lagerbuchung nicht mehr geändert werden.',
  },
  en: {
    loadError: 'Base units could not be loaded.',
    unavailable: 'This base unit is unavailable. Save it in guided setup first.',
    locked: 'The base unit cannot be changed after the first stock movement.',
  },
  tr: {
    loadError: 'Temel birimler yüklenemedi.',
    unavailable: 'Bu temel birim kullanılamıyor. Önce rehberli kurulumda kaydedin.',
    locked: 'İlk stok hareketinden sonra temel birim değiştirilemez.',
  },
  fr: {
    loadError: 'Impossible de charger les unités de base.',
    unavailable:
      'Cette unité de base est indisponible. Enregistrez-la d’abord dans la configuration guidée.',
    locked: 'L’unité de base ne peut plus être modifiée après le premier mouvement de stock.',
  },
  es: {
    loadError: 'No se pudieron cargar las unidades base.',
    unavailable:
      'Esta unidad base no está disponible. Guárdela primero en la configuración guiada.',
    locked: 'La unidad base no se puede cambiar después del primer movimiento de existencias.',
  },
};
